import * as React from 'react';
import { ArticleHeading4, UIText2 } from '@cian/ui-kit';

import { SuperAgentStar } from '../../../SuperAgent';

import * as styles from './styles.css';

interface IRealtorCardProps {
  previewImg: React.ReactNode;
  name: string;
  isSuperAgentStarShown?: boolean;
  agencyName?: string | null;
  timeOnSite?: string | null;
}

export const RealtorCard: React.FC<React.PropsWithChildren<IRealtorCardProps>> = ({
  name,
  agencyName,
  timeOnSite,
  previewImg,
  isSuperAgentStarShown,
}) => {
  return (
    <div className={styles['card']}>
      <div className={styles['img']}>{previewImg}</div>
      <div className={styles['name']}>
        <ArticleHeading4 textAlign="center">{name}</ArticleHeading4>
        {isSuperAgentStarShown && <SuperAgentStar />}
      </div>

      <UIText2 color="text-secondary-default">{agencyName}</UIText2>
      <UIText2 color="text-secondary-default">{timeOnSite}</UIText2>
    </div>
  );
};

RealtorCard.displayName = 'RealtorCard';
